// extracted by mini-css-extract-plugin
export default {"fallback-container":"styles_fallback-container__EQja4","font-name":"styles_font-name__pTnWj"};